/**
 *
 * @param {Map<String, any>} defaults
 * @param {Map<String, any>} map
 * @returns {Map<String, any>}
 */
const setDefaultParameters = (defaults, map) => {
  for (const [name, array] of defaults) {
    const parameter = new Map(
      /** @type {Array<[keyof DefaultOptionObjectProps, any]>} */
      ([
        ["is-default", true],
        ["name", name],
        [
          "resolutions",
          new Map([
            [
              "current",
              new Map(
                /** @type {Array<[string, any]>} */ ([
                  ["is-number", true],
                  ["is-page", false],
                  ["value", array[0]],
                  ["unit", array[1]],
                ])
              ),
            ],
          ]),
        ],
        ["v_value", array[0]],
        ["v_unit", array[1]],
      ])
    );

    map.set(name, parameter);
  }

  return map;
};

export default setDefaultParameters;
